export const quizAdmin: Record<string, string> = {
  // "Game" thay "Quiz" trên nhãn hiển thị (2026-08-18) — URL /quiz giữ nguyên, chỉ đổi chữ.
  'nav.quiz': 'Game',
  'nav.quiz.play': 'Chơi game',
  'nav.quiz.host': 'Host ván chơi',
  'nav.quiz.history': 'Lịch sử ván',
  'nav.quiz.admin': 'Quản lý Game',
  'quiz.listTitle': 'Danh sách Quiz',
  'quiz.newQuiz': 'Tạo Quiz',
  'quiz.editQuiz': 'Sửa Quiz',
  'quiz.emptyList': 'Chưa có quiz nào. Tạo quiz đầu tiên!',
  'quiz.colTitle': 'Tiêu đề',
  'quiz.colQuestions': 'Số câu',
  'quiz.colUpdated': 'Cập nhật',
  'quiz.deleteConfirm': 'Xoá quiz này?',
  'quiz.titlePlaceholder': 'Tiêu đề quiz',
  'quiz.descPlaceholder': 'Mô tả (tuỳ chọn)',
  'quiz.question': 'Câu hỏi',
  'quiz.slide': 'Slide',
  'quiz.questionText': 'Nội dung câu hỏi',
  'quiz.option': 'Đáp án',
  'quiz.timeLimit': 'Thời gian',
  'quiz.multiplier': 'Hệ số điểm',
  'quiz.addQuestion': 'Thêm câu hỏi',
  'quiz.addSlide': 'Thêm slide',
  // Câu gõ chữ ("Vua Tiếng Việt") — chấm đúng hoa/thường/dấu/cách giữa từ.
  'quiz.textQuestion': 'Câu gõ chữ',
  'quiz.addTextQuestion': 'Thêm câu gõ chữ',
  'quiz.textAnswerPlaceholder': 'Đáp án chính xác (phân biệt hoa/thường, dấu, khoảng cách)',
  'quiz.textRuleHint': 'Chấm đúng tuyệt đối hoa/thường, dấu và khoảng cách giữa từ. Khoảng trắng thừa đầu/cuối và cách đôi được bỏ qua. Máy chấm là chung thẩm — gõ thử bên dưới trước khi lưu.',
  'quiz.tryAnswerPlaceholder': 'Gõ thử đáp án để kiểm tra chấm…',
  'quiz.tryCorrect': 'Đúng',
  'quiz.tryWrong': 'Sai',
  'quiz.bonusMax': 'Bonus tốc độ tối đa',
  'quiz.hintPlaceholder': 'Gợi ý (tuỳ chọn) — hiện cho cả phòng giữa giờ',
  'quiz.hintDelayTitle': 'Gợi ý xuất hiện sau bao nhiêu phần thời gian',
  'quiz.hintDelayHalf': 'Sau 1/2 thời gian',
  'quiz.hintDelayThird': 'Sau 1/3 thời gian',
  'quiz.bonusMaxHint': 'Đúng = 1000 điểm + bonus theo thời gian còn lại (tối đa số này). Để thấp để kiến thức quyết định, không phải tốc độ gõ.',
  'quiz.slideTitle': 'Tiêu đề slide',
  'quiz.slideContent': 'Nội dung slide',
  'quiz.slideImage': 'URL ảnh (tuỳ chọn)',
  'quiz.hostsTitle': 'Người được quyền host',
  'quiz.permanentHost': 'Cố định',
  'quiz.addHost': 'Thêm host',
  'quiz.hostOnly': 'Trang này dành cho Quiz host. Liên hệ admin để được cấp quyền.',
};
